
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomumbaiertigaonrent() {



    const cardData =
    {
        keyword: ' Pune to Mumbai Ertiga On rent ',
        heading: 'Prince Cabs: Pune to Mumbai Ertiga On rent',
        headingDescription: 'Prince Cabs offers affordable Pune to Mumbai Ertiga on Rent, perfect for family trips, corporate travel, airport transfers, and outstation journeys. Our spacious and well-maintained Ertiga vehicles provide a comfortable and safe ride along the Pune–Mumbai Expressway. With professional chauffeurs, timely pickups, and transparent pricing, we make your Pune to Mumbai travel smooth and hassle-free. Choose Prince Cabs’ trusted Ertiga rental service from Pune to Mumbai for comfort, reliability, and affordability.',

        top: 'Top Places to Visit in Mumbai  with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most recognized monument facing the Arabian Sea. Constructed in Indo-Saracenic style, it was built to commemorate the visit of King George V and Queen Mary. Today, it is a popular hangout for locals and tourists, with ferry rides to Elephanta Caves starting here. Sunsets and night lighting make it even more enchanting. Surrounded by vendors and photographers, it is always lively. Gateway of India remains the pride of South Mumbai."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km curved boulevard along the Arabian Sea. At night, its lights resemble a necklace, creating a mesmerizing effect. Locals and tourists love it for jogging, evening walks, and sea views. During monsoon, waves crash dramatically onto the promenade. Sunsets here are breathtakingly beautiful. Marine Drive captures Mumbai’s modern and vibrant spirit."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and one of Mumbai’s busiest railway stations. Built in 1887, it features Gothic Revival architecture with stained glass windows, domes, and carvings. The station glows magnificently when illuminated at night. It is both a functional hub and an architectural masterpiece. Visitors admire its heritage beauty while experiencing Mumbai’s train culture. CST is a blend of history and daily life."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating back to the 5th–6th centuries. The highlight is the massive Trimurti statue of Lord Shiva. The caves display ancient Indian artistry and spiritual significance. Accessible by ferry from Gateway of India, the trip itself is scenic. Surrounded by greenery, the island offers peace from the city rush. Elephanta is a must-visit for heritage and history lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its street food stalls and relaxed vibe. Pav bhaji, bhel puri, and ice gola are favorites among visitors. Families, couples, and tourists gather here in the evenings for leisure. Bollywood celebrities residing nearby make it a hotspot for star spotting. Sunsets at Juhu are stunningly beautiful. The beach reflects Mumbai’s fun and coastal culture."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it draws thousands of devotees daily, including celebrities and politicians. The golden dome and intricate wood carvings add grandeur. Tuesdays are especially busy with massive gatherings for darshan. Devotees believe wishes made here are fulfilled. It is the spiritual heartbeat of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge that connects South Mumbai with its suburbs. It is an engineering marvel offering panoramic sea views. Driving across it, especially at night when lit up, is unforgettable. It has cut travel time significantly, easing city traffic. The bridge is both practical and scenic. It stands as a modern icon of Mumbai’s progress and ambition."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a renowned Sufi shrine situated on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is accessible via a causeway during low tide. Its Indo-Islamic design is striking against the sea backdrop. Devotees from all faiths visit to seek blessings. The serene setting adds to its spiritual aura. Haji Ali is Mumbai’s landmark of faith and unity."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s busiest shopping street, lined with vendors and boutiques. Visitors shop for jewelry, clothes, handicrafts, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to its charm. Bargaining with vendors is part of the fun. The market is always buzzing with locals and tourists. Colaba Causeway is Mumbai’s ultimate shopping and cultural hub."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan festivities. Families love enjoying snacks like pav bhaji, kulfi, and bhel here. The beach becomes especially vibrant during cultural events and fairs. It offers stunning views of Marine Drive’s arc and the Arabian Sea. Children enjoy playing in the sand and waves. Chowpatty is Mumbai’s mix of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the beating heart of Bollywood filmmaking, spread across 500 acres. It has multiple studios, artificial sets, and shooting zones for films and TV shows. Visitors can take guided tours to explore behind-the-scenes action. Cinema enthusiasts love spotting live shoots here. It is one of the largest film complexes in the world. Film City defines Mumbai as India’s entertainment capital."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a massive green reserve within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display ancient Buddhist monasteries and stupas dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks here. It is rare to find such biodiversity in a metro city. The park blends history, adventure, and wildlife."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is a man-made lake surrounded by greenery and modern skyscrapers. It is popular for birdwatching, with species like herons and kingfishers often seen here. Joggers and photographers enjoy its peaceful promenade. During monsoon, the lake looks especially scenic with misty views. Families enjoy picnics by the waterside. Powai Lake offers calm amidst the chaos of Mumbai."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda, near Gorai, is one of the largest meditation domes in the world. Built in Burmese architectural style, it houses sacred relics of Buddha. The golden dome can seat thousands of meditators. Visitors attend sessions and admire its stunning design. Its seaside setting enhances its peaceful ambiance. The pagoda symbolizes spirituality, peace, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is a favorite destination for astronomy enthusiasts. It features dome-shaped sky shows that explain stars, galaxies, and cosmic phenomena. The adjoining Science Centre has interactive exhibits on technology and innovation. Families and students enjoy its educational yet fun environment. Special events are held during eclipses and celestial activities. It is Mumbai’s hub of science and exploration."
  }
],

"services": [
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Book an Ertiga cab from Pune to Mumbai for a smooth and spacious travel experience. This 7-seater vehicle is ideal for families, groups, or business travelers seeking comfort and reliability on the intercity route."
  },
  {
    "name": "Ertiga for Mumbai Drop from Pune",
    "description": "Get a convenient one-way drop from Pune to Mumbai in a well-maintained Ertiga. Enjoy hassle-free pickup, smooth ride quality, and professional service tailored for outstation transfers."
  },
  {
    "name": "7 Seater Ertiga Pune to Mumbai",
    "description": "Travel with your group or family in a 7-seater Ertiga from Pune to Mumbai. Spacious seating, ample luggage space, and AC comfort make it the perfect vehicle for long-distance journeys."
  },
  {
    "name": "Ertiga One Way Cab Pune to Mumbai",
    "description": "Hire a one-way Ertiga cab from Pune to Mumbai for cost-effective and reliable transport. Enjoy timely service, clean vehicles, and experienced drivers for a pleasant travel experience."
  },
  {
    "name": "Family Car Ertiga Pune to Mumbai",
    "description": "Book an Ertiga as your family car for the Pune to Mumbai route. With comfortable seating and safety features, it’s the preferred choice for parents, kids, and elderly travelers."
  },
  {
    "name": "Pune to Mumbai Affordable Ertiga Rental",
    "description": "Get affordable rates on Ertiga rentals for Pune to Mumbai travel. Transparent pricing and no hidden charges make this an economical option for small groups and frequent travelers."
  },
  {
    "name": "Pune to Mumbai AC Ertiga Hire",
    "description": "Hire a fully air-conditioned Ertiga from Pune to Mumbai for a cool and comfortable ride. Ideal for all weather conditions, whether it’s business, leisure, or airport transfers."
  },
  {
    "name": "Pune to Mumbai Ertiga Crysta Taxi",
    "description": "Travel in upgraded comfort with the Ertiga Crysta taxi from Pune to Mumbai. A stylish MPV perfect for executive or luxury travel at a mid-range budget."
  },
  {
    "name": "Pune to Mumbai Round Trip Ertiga",
    "description": "Plan a round trip from Pune to Mumbai in an Ertiga cab with the same driver. Great for day trips, business meetings, or quick family visits where return travel is required."
  },
  {
    "name": "Pune to Mumbai SUV Ertiga Cab",
    "description": "Hire an SUV-style Ertiga for your Pune to Mumbai journey. A blend of power, comfort, and utility, this cab handles both city and highway travel efficiently."
  },
  {
    "name": "Pune to Mumbai Car with Driver Ertiga",
    "description": "Rent an Ertiga with a professional driver for your Pune to Mumbai trip. Enjoy door-to-door service, safe driving, and local route expertise throughout the ride."
  },
  {
    "name": "Ertiga Outstation Cab Pune to Mumbai",
    "description": "Use our Ertiga outstation cab services from Pune to Mumbai for business, personal, or family travel. Flexible scheduling and dedicated customer support included."
  },
  {
    "name": "Pune to Mumbai Group Trip Ertiga",
    "description": "Planning a group trip? Choose an Ertiga cab for your Pune to Mumbai travel needs. Ideal for 5–6 passengers with luggage, offering great value and comfort."
  },
  {
    "name": "Wedding Travel Pune to Mumbai Ertiga",
    "description": "Book an Ertiga cab for transporting wedding guests or family members from Pune to Mumbai. Comfortable, stylish, and perfect for handling multiple pickups or long-distance travel."
  },
  {
    "name": "Pune to Mumbai Comfortable Ertiga",
    "description": "Experience comfort and reliability with our Ertiga cab service from Pune to Mumbai. With smooth suspension, AC, and ample space, it’s designed for long journeys."
  }
],
"tableData": [
  ["Pune to Mumbai Ertiga Cab", "Ertiga for Mumbai Drop from Pune"],
  ["7 Seater Ertiga Pune to Mumbai", "Ertiga One Way Cab Pune to Mumbai"],
  ["Family Car Ertiga Pune to Mumbai", "Pune to Mumbai Affordable Ertiga Rental"],
  ["Pune to Mumbai AC Ertiga Hire", "Pune to Mumbai Ertiga Crysta Taxi"],
  ["Pune to Mumbai Round Trip Ertiga", "Pune to Mumbai SUV Ertiga Cab"],
  ["Pune to Mumbai Car with Driver Ertiga", "Ertiga Outstation Cab Pune to Mumbai"],
  ["Pune to Mumbai Group Trip Ertiga", "Wedding Travel Pune to Mumbai Ertiga"],
  ["Pune to Mumbai Comfortable Ertiga"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Ertiga on Rent from Pune to Mumbai",
    "WhyChoosedescription": "Prince Cabs offers dependable and comfortable Ertiga rental services for one-way and round trips between Pune and Mumbai. Ideal for families, business groups, and tourists, our service ensures timely pickups, well-planned routes, and a relaxed journey with complete door-to-door convenience."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Ertiga for Long-Distance Travel",
    "WhyChoosedescription": "Our Maruti Suzuki Ertiga vehicles are perfect for long intercity journeys like Pune to Mumbai. With seating for up to 6 passengers plus a driver, along with ample luggage space, air conditioning, and comfortable interiors, the Ertiga offers a smooth and stress-free travel experience for both short and long rides."
  },
  {
    "WhyChooseheading": "Customizable Rental Options to Suit Your Trip",
    "WhyChoosedescription": "Choose from one-way rentals, round trips, or full-day bookings as per your travel needs. Whether it's an airport drop, business meeting, or family visit, Prince Cabs provides flexible rental plans with clear terms. We also offer Ertiga on rent for multi-day use if you plan to return to Pune after a few days."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "All Ertiga rentals come with professional drivers who are well-versed with the Pune to Mumbai route. They ensure safe driving, timely breaks, and efficient navigation through expressways and city traffic, making your intercity travel smooth and punctual."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our Pune to Mumbai Ertiga rental pricing includes all essential costs like fuel, tolls, driver allowance, and taxes. There are no hidden fees, and you’ll receive a complete fare estimate before booking. We accept multiple secure payment options including UPI, credit/debit cards, net banking, and cash."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Safe Vehicles",
    "WhyChoosedescription": "We prioritize your safety and hygiene by thoroughly sanitizing each Ertiga before every trip. Our vehicles are routinely maintained and equipped with safety features such as airbags, seat belts, and emergency supplies, ensuring a secure travel experience for all passengers."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Ride",
    "WhyChoosedescription": "Our dedicated customer care team is available round the clock to help with bookings, schedule changes, or last-minute adjustments. Whether you're traveling early morning or late at night, Prince Cabs ensures seamless support from Pune to Mumbai and beyond."
  }
]

































    }

const faqData = [
    {
        question: 'Can I rent an Ertiga for a Pune to Mumbai trip with Prince Cabs?',
        answer: 'Yes, Prince Cabs offers spacious and comfortable Ertiga vehicles on rent for Pune to Mumbai one-way and round trips.',
    },
    {
        question: 'Is the Ertiga suitable for long-distance travel like Pune to Mumbai?',
        answer: 'Absolutely! Ertiga is ideal for intercity travel due to its comfort, ample legroom, and luggage space—perfect for families and groups.',
    },
    {
        question: 'Are the Ertiga cabs well-maintained and sanitized?',
        answer: 'Yes, all Ertiga vehicles are thoroughly cleaned, sanitized, and serviced regularly to ensure safety and comfort during your journey.',
    },
    {
        question: 'Does the Ertiga rental include a driver?',
        answer: 'Yes, our Ertiga rentals come with a professional, experienced, and courteous driver for a stress-free trip.',
    },
    {
        question: 'What is the fare for renting an Ertiga from Pune to Mumbai?',
        answer: 'Fares depend on trip type (one-way or round trip), distance, and travel time. Please contact Prince Cabs for an accurate quote.',
    },
    {
        question: 'How do I book an Ertiga on rent for Pune to Mumbai?',
        answer: 'You can easily book through our website or by calling our customer support team for quick assistance.',
    },
    {
        question: 'Is there an option for round-trip bookings with Ertiga?',
        answer: 'Yes, Prince Cabs offers flexible round-trip packages for Ertiga rentals between Pune and Mumbai at competitive rates.',
    },
];

const testimonials = [
    {
        name: "Mr. Ajay Naik",
        position: "Frequent Traveler",
        text: "I booked an Ertiga for a Pune to Mumbai trip with Prince Cabs. The ride was smooth, and the vehicle was clean and spacious.",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-mumbai-1.png",
    },
    {
        name: "Ms. Kavya Bhosale",
        position: "Family Traveler",
        text: "Prince Cabs provided an Ertiga for our family trip from Pune to Mumbai. The driver was polite and the journey was very comfortable.",
        image: "/img/testimonial/testimonial-thumb-ertiga-pune-mumbai-2.png",
    },
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Mumbai Ertiga On Rent",
  "description": "Affordable and comfortable 7 Seater Ertiga cab service from Pune to Mumbai for one way, round trip, family trips, group travel, weddings, and corporate rides with experienced drivers.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Mumbai Ertiga Cab",
    "Ertiga for Mumbai Drop from Pune",
    "7 Seater Ertiga Pune to Mumbai",
    "Ertiga One Way Cab Pune to Mumbai",
    "Family Car Ertiga Pune to Mumbai",
    "Pune to Mumbai Affordable Ertiga Rental",
    "Pune to Mumbai AC Ertiga Hire",
    "Pune to Mumbai Ertiga Crysta Taxi",
    "Pune to Mumbai Round Trip Ertiga",
    "Pune to Mumbai SUV Ertiga Cab",
    "Pune to Mumbai Car with Driver Ertiga",
    "Ertiga Outstation Cab Pune to Mumbai",
    "Pune to Mumbai Group Trip Ertiga",
    "Wedding Travel Pune to Mumbai Ertiga",
    "Pune to Mumbai Comfortable Ertiga"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Ertiga On Rent | 7 Seater Ertiga Cab Service</title>
  <meta
    name="description"
    content="Book affordable and comfortable 7 Seater Ertiga cab from Pune to Mumbai for one way, round trip, family trips, group travel, weddings, and corporate rides with driver."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Ertiga Cab, Ertiga for Mumbai Drop from Pune, 7 Seater Ertiga Pune to Mumbai, Ertiga One Way Cab Pune to Mumbai, Family Car Ertiga Pune to Mumbai, Pune to Mumbai Affordable Ertiga Rental, Pune to Mumbai AC Ertiga Hire, Pune to Mumbai Ertiga Crysta Taxi, Pune to Mumbai Round Trip Ertiga, Pune to Mumbai SUV Ertiga Cab, Pune to Mumbai Car with Driver Ertiga, Ertiga Outstation Cab Pune to Mumbai, Pune to Mumbai Group Trip Ertiga, Wedding Travel Pune to Mumbai Ertiga, Pune to Mumbai Comfortable Ertiga"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaiertigaonrent ;